import { gql } from "graphql-tag";

export const GET_ANALYTICS_DEDUCTION_VOLUME_VS_GROSS_SALES = gql`
  query AnalyticsDeductionVolumeVsGrossSales($params: GetAnalyticsInput!) {
    analyticsDeductionVolumeVsGrossSales(params: $params) {
      month
      monthLabel
      deductions
      grossSales
      deductionsPctOfSales
    }
  }
`;
